import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full es-select row" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onselect"]
const _hoisted_4 = ["value"]

import { ref, watch } from 'vue';
import SharedService from "@/services/SharedService";
import { ItemSelect } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esSelect',
  props: {
    options: {},
    selectedData: {},
    icon: {},
    iconSubPath: {}
  },
  emits: ['changeSelect'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentOption = ref<ItemSelect> (props.selectedData);

const emits = __emit

watch(
  () => props.selectedData,
  (newSelectedData: ItemSelect) => {
    if (newSelectedData) {
        currentOption.value = newSelectedData;
    }
  },
  { deep: true }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(SharedService).getIcon(_ctx.icon, false, _ctx.iconSubPath),
          class: "pleft-06 img-grey"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentOption).value = $event)),
      class: "w-full",
      onselect: emits('changeSelect', currentOption.value)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.id,
          value: option
        }, _toDisplayString(option.label), 9, _hoisted_4))
      }), 128))
    ], 8, _hoisted_3), [
      [_vModelSelect, currentOption.value]
    ])
  ]))
}
}

})